import * as Yup from 'yup'

const availabilitySchema = Yup.object({
    availability:Yup.array().min(1, 'INPUT.VALIDATION.AVAILABILITY')
})
export default availabilitySchema;